<template>
  <TableGradient
      icon-name="control"
      :title="$t('reportControl.listagem.titulo_pagina')"
      :text-empty="$t('reportControl.listagem.table.empty')"
      :fields="fields"
      :fields-filter="filter"
      :items="reportControls"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('reportControl/listAll', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="`link-edit-${linha.index}`" :to="{ name: 'vns.report_control.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('reportControl.listagem.table.editar') }}
      </router-link>
    </template>    
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      reportControls: 'reportControl/all',
      paginator: 'reportControl/pagination',
      reportControlIsLoading: 'reportControl/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.reportControlIsLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'vns', label: this.$t('reportControl.listagem.table.nome'), sortable: true, keyFullName: 'vns.name'},
        {key: 'company_name', label: this.$t('reportControl.listagem.table.empresa'), sortable: true},
        {key: 'report_control', label: this.$t('reportControl.listagem.table.resultado_descartavel')},
        {key: 'id', label: this.$t('reportControl.listagem.table.editar')}
      ],
      filter: [
        {key: 'vns', label: this.$t('reportControl.listagem.table.nome')},
        {key: 'company_name', label: this.$t('reportControl.listagem.table.empresa')},
      ]
    }
  },
  methods: {
    ...mapActions([
      'reportControl/listAll'
    ])
  },
  mounted() {
    this['reportControl/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
